import { Injectable } from '@angular/core';

import { EnableClassTelemetry } from 'app/services/otel.service';

export type TimerFn = (name: string, props?: any) => number;

@EnableClassTelemetry()
@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  private installed = false;

  constructor() {}

  public sendEvent(
    eventName: string,
    eventCategory: string = null,
    label: string = null,
    value: number = null
  ) {
    this.eventEmitter(eventName, {
      event_category: eventCategory,
      event_label: label,
      value,
    });
  }

  private eventEmitter(_eventName: string, _properties: any) {
    if (!this.installed) {
      return;
    }
  }

  public createTimer(eventCategory: string): TimerFn {
    const started = +new Date();
    return (name, props) => {
      const now = +new Date();
      const timeSincePageLoad = Math.round(now - started);

      const mainProps = {
        name,
        value: timeSincePageLoad,
        event_category: eventCategory,
      };
      const properties = { ...props, ...mainProps };
      this.eventEmitter('timing_complete', properties);
      return timeSincePageLoad;
    };
  }
}
